export default "__VITE_ASSET__BthTCY4r__"